export const CONTACT = {
  VK: 'https://vk.com/noty_dlya_fortepiano',
  FS_RU: 'https://www.facebook.com/notestorerus/',
  FS: 'https://www.facebook.com/notestorecom/',
  YOUTUBE: 'https://www.youtube.com/@note-store/',
  PINTEREST_RU: 'https://ru.pinterest.com/notestoreru/',
  PINTEREST: 'https://ru.pinterest.com/notestorecom/',
  PINTEREST_DE: 'https://ru.pinterest.com/notestorede/',
};
